<template>
<div class="page-container test-page">
    <amf-form title="Form 1" style="height: 200px;" class="form-group">
        <div class="row">
            <amf-input label="input A" v-model="testA" class="col-4 form-group"></amf-input>
            <amf-input label="input B" v-model="testB" class="col-4 form-group"></amf-input>
            <amf-button label="button B" :onClick="clear" class="col-4 btn-success">Clear</amf-button>
        </div>
        <table class="mt-2 table table-sm table-condensed table-hover">
            <tbody>
                <tr @click="showInfo">
                    <td>Apple</td>
                    <td>per pound</td>
                    <td>1.00</td>
                </tr>
                <tr @click="showInfo">
                    <td>Banana</td>
                    <td>per pound</td>
                    <td>0.75</td>
                </tr>
            </tbody>
        </table>
    </amf-form>

    <amf-form title="Form 2" class="form-group">
        <amf-form-row ref="formRow" label="Row 1" edit-summary="Edit summary text 1" 
            :view-summary="viewSummary" :onEdit="onEdit" :onSave="save">
            <amf-input label="input 1" v-model="test1" :validator="$v.req" class="col-4 form-group"></amf-input>
            <amf-datepicker label="date 1" v-model="date1" :validator="$v.req" class="col-4 form-group"></amf-datepicker>
            <amf-select label="Select 1" v-model="select1" :validator="$v.req" caption="--Type--" :options="accountTypes" class="col-4 form-group" />
            <amf-checkbox label="checkbox 1" v-model="checkbox1" :validator="$v.req" class="col-4 form-group"></amf-checkbox>
            <!-- <amf-textarea label="textarea 1" v-model="textarea1" :validator="$v.req" class="col-12 form-group"></amf-textarea> -->
        </amf-form-row>
        <amf-form-row ref="formRow" label="Row 2" edit-summary="Edit summary text 2" 
            :view-summary="viewSummary" :onEdit="onEdit" :onSave="save">
            <amf-input label="input 1" v-model="test1" disabled class="col-4 form-group"></amf-input>
            <amf-datepicker label="date 1" v-model="date1" disabled class="col-4 form-group"></amf-datepicker>
            <amf-select label="Select 1" v-model="select1" disabled caption="--Type--" :options="accountTypes" class="col-4 form-group" />
            <amf-checkbox label="checkbox 1" v-model="checkbox1" disabled class="col-4 form-group"></amf-checkbox>
        </amf-form-row>
        <amf-collection-row 
            v-bind:label="'Collection 1'"
            v-bind:items="contacts"
            v-on:click="showModal">
        </amf-collection-row>
    </amf-form>
</div>
</template>

<script>
import TestModal from "./TestModal";

export default {
    props: ['id'],
    data() {
        return {
            testA: null,
            testB: null,
            test1: null,
            date1: null,
            select1: null,
            checkbox1: null,
            textarea1: null,
            accountTypes: [
                { id: 1, name: 'Checking' },
                { id: 2, name: 'Savings' }
            ],
            contacts: [
                {
                    firstName: "John",
                    lastName: "Doe",
                    text: "John Doe",
                    showModal: this.showModal,
                }, 
                {
                    firstName: "Jane",
                    lastName: "Doe",
                    text: "Jane Doe",
                    showModal: this.showModal,
                },
            ],
        }
    },
    methods: {
        onEdit() {
        
        },
        async save() {

        },
        async clear() {
            this.testA = null;
            this.testB = null;
        },
        async showModal(contact) {
            var data = await modalService.show("test-modal", TestModal, { });
            return false;
        },
        async showInfo() {
            var data = await modalService.info("Test info modal");
            return false;
        },
    },
    computed: {
        viewSummary() {
            return "View summary info"
        },
        menuItems() {
            return ["Link 1"];
        },
    },
    validations() {
        return {
            req: v.build(v.required()),
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/tests/TestPage.vue